import { useEffect, useState } from "react";
import { fetchHorarios } from "../../../controller/HorarioController";
import { useNavigate } from "react-router-dom";
import { Container, Table, Button } from "react-bootstrap";
import { PencilSquare, Plus } from "react-bootstrap-icons";

function HorarioView() {
  const [horarios, setHorarios] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const obtenerHorarios = async () => {
      try {
        const data = await fetchHorarios();
        setHorarios(data);
      } catch (error) {
        console.error('Error al obtener los horarios:', error);
      }
    };
    obtenerHorarios();
  }, []);

  const handleCreateHorario = () => {
    navigate('/horario/create');
  };

  const handleEditHorario = (horario) => {
    navigate("/horario/edit", {
      state: { horario: horario },
    });
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Horarios</h1>
        <Button variant="primary" onClick={handleCreateHorario}>
          <Plus className="me-2" /> Crear Horario
        </Button>
      </div>

      {horarios.length > 0 ? (
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Hora Inicio</th>
              <th>Hora Fin</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {horarios.map((horario) => (
              <tr key={horario.id}>
                <td>{horario.nombre}</td>
                <td>{horario.hora_inicio}</td>
                <td>{horario.hora_fin}</td>
                <td>
                  <Button
                    variant="light"
                    size="sm"
                    onClick={() => handleEditHorario(horario)}
                  >
                    <PencilSquare color="blue" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No hay horarios registrados.</p>
      )}
    </Container>
  );
}

export default HorarioView;
